import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = {
  key: 1,
  class: "grid"
}
const _hoisted_3 = {
  key: 0,
  class: "col"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "col md:col-6 xl:col-4"
}
const _hoisted_6 = { class: "form-question-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 3,
  class: "col"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 4,
  class: "col"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "declaration-container" }
const _hoisted_16 = {
  key: 0,
  class: "button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_ActionHeader = _resolveComponent("ActionHeader")!
  const _component_FormQuestions = _resolveComponent("FormQuestions")!
  const _component_Declaration = _resolveComponent("Declaration")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Signature = _resolveComponent("Signature")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ActionHeader, {
      hotspotDescription: _ctx.hotspotDescription,
      actionTitle: _ctx.actionTitle,
      actionDescription: _ctx.actionDescription
    }, _createSlots({ _: 2 }, [
      (!_ctx.actionProgress?.completed)
        ? {
            name: "description",
            fn: _withCtx(() => [
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "form.all.required" })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["hotspotDescription", "actionTitle", "actionDescription"]),
    _createElementVNode("div", {
      class: _normalizeClass(["hotspot-action--form styled-content", _ctx.actionProgress?.completed ? 'form-complete' : ''])
    }, [
      (!_ctx.actionProgress?.completed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_FormQuestions, {
              formQuestions: _ctx.formQuestions,
              fileSizeLimit: _ctx.fileSizeLimit.toString(),
              userResponses: _ctx.userResponses,
              uploadFiles: _ctx.uploadFiles,
              safeUrls: _ctx.safeUrls,
              safeHTML: _ctx.safeHTML,
              errorsRef: _ctx.errorsRef,
              onDoChange: _ctx.handleDoChange,
              onSelectChange: _ctx.handleSelectChange,
              onChoiceChange: _ctx.handleChoiceChange,
              onCheckboxChange: _ctx.handleCheckboxChange,
              onDateChange: _ctx.handleDateChange,
              onUpdateFileList: _ctx.updateFileList
            }, null, 8, ["formQuestions", "fileSizeLimit", "userResponses", "uploadFiles", "safeUrls", "safeHTML", "errorsRef", "onDoChange", "onSelectChange", "onChoiceChange", "onCheckboxChange", "onDateChange", "onUpdateFileList"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.actionProgress?.completed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formQuestions, (formQuestion) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: formQuestion.id
              }, [
                (
              formQuestion.questionType === 'title' &&
              _ctx.dependencyCheck(formQuestion.id)
            )
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.getTextItem(formQuestion.textItems, "form-question")), 1))
                  : _createCommentVNode("", true),
                (
              formQuestion.questionType === 'prompt' &&
              _ctx.dependencyCheck(formQuestion.id)
            )
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "col",
                      innerHTML: _ctx.sanitizeTextItem(formQuestion.textItems)
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (
              formQuestion.questionType === 'image' &&
              _ctx.dependencyCheck(formQuestion.id)
            )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, [
                        _createElementVNode("img", {
                          class: "form-img-responsive",
                          src: _ctx.safeUrls[formQuestion.imageReference]
                        }, null, 8, _hoisted_7)
                      ]),
                      _createElementVNode("span", {
                        class: "form-question-image-title",
                        innerHTML: _ctx.sanitizeTextItem(formQuestion.textItems)
                      }, null, 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                (formQuestion.userResponses.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                      _createElementVNode("label", {
                        innerHTML: _ctx.sanitizeTextItem(formQuestion.textItems)
                      }, null, 8, _hoisted_10),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formQuestion.userResponses, (userResponse) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: userResponse.id
                        }, [
                          (
                  (formQuestion.questionType == 'date' ||
                    formQuestion.questionType == 'date-of-birth') &&
                  _ctx.dependencyCheck(formQuestion.id)
                )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(userResponse.responseValue), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(userResponse.responseValue
                    ? userResponse.responseValue.replace(/,/g, ", ")
                    : ""), 1))
                        ], 64))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (
              ['imageupload', 'pdfupload', 'genericupload'].includes(
                formQuestion.questionType
              )
            )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _createElementVNode("label", {
                        innerHTML: _ctx.sanitizeTextItem(formQuestion.textItems)
                      }, null, 8, _hoisted_14),
                      _createElementVNode("span", null, _toDisplayString(formQuestion.userResponses.length > 0
                  ? "Document Provided"
                  : "Not Provided"), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_TranslatedText, { path: "declaration.sign.complete" }),
              _cache[4] || (_cache[4] = _createTextVNode(" - ", -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.completionDateString), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        (!_ctx.wetSignature && !_ctx.actionProgress?.completed)
          ? (_openBlock(), _createBlock(_component_Declaration, {
              key: 0,
              modelValue: _ctx.declaration,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.declaration) = $event)),
              isValid: _ctx.declarationIsValid,
              "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declarationIsValid) = $event)),
              line1: ''
            }, null, 8, ["modelValue", "isValid"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (!_ctx.actionProgress?.completed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_Button, {
            text: "declaration.sign",
            size: "sm",
            onClick: _ctx.handleSignClick,
            disabled: !_ctx.isDirty || (_ctx.wetSignature && _ctx.showSign)
          }, null, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showSignModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showSignModal) = $event)),
      title: "signature.title",
      showFooter: false,
      onCancel: _ctx.handleModalHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Signature, {
          modelValue: _ctx.declarationWet,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.declarationWet) = $event)),
          onConfirm: _ctx.handleSignSubmit,
          onCancel: _ctx.handleModalHide
        }, null, 8, ["modelValue", "onConfirm", "onCancel"])
      ]),
      _: 1
    }, 8, ["modelValue", "onCancel"])
  ]))
}